<template>
  <!-- Group Bulk Assign-->
  <b-modal
    id="bulk-assign"
    ref="bulk-assign"
    centered
    title="Bulk Assign"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
  >
    <form
      ref="form"
      class="px-4"
    >
      <b-row>

        <b-col
          sm="12"
          class="mb-1"
        >
          <b-form-group
            label="Select CSV File"
          >
            <b-form-file
              ref="refInputEl"
              v-model="importFile"
              accept=".csv"
              placeholder="Choose file"
              @change="handleFileChange"
            />
          </b-form-group>

          <b-link
            @click="exportExampleCSV"
          >
            <u>Download Template CSV</u>
          </b-link>
        </b-col>

      </b-row>
    </form>

    <div
      v-if="validationErrors.length"
      class="form-group pt-1"
    >
      <p
        v-for="(validationError, index) in validationErrors"
        :key="index"
        class="text-center text-danger"
      >
        {{ validationError }}
      </p>
    </div>

    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          class="float-right"
          :disabled="!importFile || isLoading"
          @click="uploadFile"
        >
          <b-spinner
            v-if="isLoading"
            label="Spinning"
            small
          />
          <span v-else>Bulk Assign</span>
        </b-button>
      </div>
    </template>
  </b-modal>

</template>

<script>
import {
  BRow, BCol, VBModal, BFormGroup, BFormFile, BButton, BLink, BSpinner,
} from 'bootstrap-vue'

import { useToast } from 'vue-toastification/composition'
import { title } from '@core/utils/filter'
import { downloadExportFile } from '@core/mixins/downloadExportFile'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'GroupBulkAssignModal',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormFile,
    BButton,
    BLink,
    BSpinner,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [downloadExportFile],
  data() {
    return {
      importFile: null,
      validationErrors: [],
      isLoading: false,
    }
  },
  setup() {
    // Use toast
    const toast = useToast()

    return {
      title,
      toast,
    }
  },
  methods: {
    handleFileChange(e) {
      // eslint-disable-next-line prefer-destructuring
      this.importFile = e.target.files[0]
    },
    uploadFile() {
      const formData = new FormData()
      formData.append('file', this.importFile)

      this.validationErrors = []

      this.isLoading = true

      this.$store.dispatch('app-group/importBulkAssignGroups', formData)
        .then(response => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Bulk Assign Groups operation was successful',
              text: `${response.linked_to_groups} of users were successfully linked to groups`,
              icon: 'ThumbsUpIcon',
              variant: 'info',
            },
          })
          this.$nextTick(() => {
            this.$refs['bulk-assign'].toggle('#toggle-btn')
            this.clearForm()
          })
        })
        .catch(error => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Error assigned Groups',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          if (error.response.status === 422) {
            const validationErrors = Object.values(error.response.data.errors)
            this.validationErrors = validationErrors.flat()
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clearForm() {
      this.importFile = null
      this.$emit('reload')
    },
    async exportExampleCSV() {
      this.downloadFile(['user_id', 'group_id'], 'bulk_assign_template', 'csv')
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
